import { gql } from '@apollo/client';

export const GET_DRIVER_SMS_RECORDS_BY_DRIVER_ID = gql`
    query GetDriverSmsRecordsByDriverId($driverId: Long!) {
        getDriverSmsRecordsByDriverId(driverId: $driverId) {
            id
            trackingNumber
            driverId
            stopNumber
            subStopNumber
            customerName
            recipientAddressId
            isNotReadCount
        }
    }
`;

export interface DriverSmsRecordItem {
    id: number;
    trackingNumber: string;
    driverId: number;
    stopNumber: number;
    subStopNumber: string;
    customerName: string;
    recipientAddressId : number;
    isNotReadCount: number;
}

export interface GetDriverSmsRecordsByDriverIdResponse {
    getDriverSmsRecordsByDriverId: DriverSmsRecordItem[];
}

export interface GetDriverSmsRecordsByDriverIdVariables {
    driverId: number;
}


